module.exports = __webpack_public_path__ + "static/img/file.1e62db2c.png";